import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { LabelDevice } from "@/features/device/components/LabelDevice/LabelDevice";
import type { DeviceOption } from "./-types";

const DeviceMultiSelectOption = ({ device }: { device: DeviceOption }) => (
  <HStack className="items-center gap-3 h-full min-h-[40px]">
    <LabelDevice
      name={device.label}
      avatarUrl={device.avatarUrl}
      genre={device.genre}
    />
    <VStack>
      {device.model && (
        <Text variant="labelSmall" className="text-muted-foreground">
          {device.model}
        </Text>
      )}
      {device.serialNumber && (
        <Text variant="labelSmall" className="text-muted-foreground">
          {device.serialNumber}
        </Text>
      )}
    </VStack>
  </HStack>
);

export default DeviceMultiSelectOption;
